






import { Component, Vue } from 'vue-property-decorator';
import { InteractionData } from '@/types'
import BusinessInteraction from '@/components/BusinessInteraction/BusinessInteraction'
import axios from "axios";

@Component({
  name: 'BiMarket',

  components: {
    BusinessInteraction
  }
})
export default class BiMarket extends Vue {
  BusinessInteractionData: Array<InteractionData> = [];

  mounted() {
    this.$gtag.pageview({page_path: '/bi_market'})
    axios.get(`${process.env.VUE_APP_API_URL}analytics/tasks-market`).then(value => {
      const { total: { sme, expert }, values } = value.data;
      this.BusinessInteractionData = values.map(
        (item: any) => {
         return {
           title: item.name,
           smePct: item.value.sme / sme * 100,
           expertPct: item.value.expert / expert * 100
         }
        }
      ).slice(0, 20)
    })
  }
}
